//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "Ottawa_ankle_rules",
  data() {
    return {
      form: {
        ankle :'0',
        ankleA:'0',
        ankleB: "0",
        ankleC: "0",
        midfoot:'0',
        midfootA:'0',
        midfootB:'0',
        midfootC:'0',
      },
      hasScore: false,
      disabled: false,
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      console.log(form,321);
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
       
        if(form.ankle && (form.ankleA || form.ankleB || form.ankleC)) {
          self.result = '建议行踝部X线摄片检查'
        } else if(form.midfoot && (form.midfootA || form.midfootB || form.midfootC)) {
          self.result = '建议行足部X线摄片检查'
        }else {
          self.result = ''
        }
     
        return self.result;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Ottawa_ankle_rules.vue